import { render, staticRenderFns, recyclableRender, components } from "./applicationRecord.vue?vue&type=template&id=191c240e&scoped=true&"
var renderjs
import script from "./applicationRecord.vue?vue&type=script&lang=js&"
export * from "./applicationRecord.vue?vue&type=script&lang=js&"
import style0 from "./applicationRecord.vue?vue&type=style&index=0&lang=css&"
import style1 from "./applicationRecord.vue?vue&type=style&index=1&id=191c240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c240e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "n_pages/applicationRecord/applicationRecord.vue"
export default component.exports